// extracted by mini-css-extract-plugin
export default {"cls1":"PaperSelector-cls1___99dc83ee55eb3da12ba","cls2":"PaperSelector-cls2__c5c38db8bc30a80e1f57 PaperSelector-cls1___99dc83ee55eb3da12ba"};